var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.289,
    height: 46.57,
    viewBox: "0 0 16.289 20.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "encrypted_24dp_FILL0_wght300_GRAD0_opsz24",
    d: "M186.777-845.2h2.735l-.614-3.429a1.845,1.845,0,0,0,.824-.688,1.838,1.838,0,0,0,.312-1.041,1.82,1.82,0,0,0-.554-1.335,1.82,1.82,0,0,0-1.335-.554,1.82,1.82,0,0,0-1.335.554,1.82,1.82,0,0,0-.554,1.335,1.838,1.838,0,0,0,.312,1.041,1.845,1.845,0,0,0,.824.688Zm1.368,7.309a10.489,10.489,0,0,1-5.834-4.147A11.848,11.848,0,0,1,180-849.163v-6.248l8.145-3.049,8.144,3.049v6.248a11.848,11.848,0,0,1-2.311,7.125A10.489,10.489,0,0,1,188.145-837.89Zm0-1.717a8.837,8.837,0,0,0,4.669-3.584,10.314,10.314,0,0,0,1.846-5.973v-5.131l-6.516-2.433-6.516,2.433v5.131a10.314,10.314,0,0,0,1.846,5.973A8.837,8.837,0,0,0,188.145-839.607ZM188.145-848.175Z",
    transform: "translate(-180 858.46)",
    fill: "#1447b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthServicesIcon);
export default __webpack_public_path__ + "static/media/auth_services_icon.83d5f285d7125507b61ed101a2fd182a.svg";
export { ForwardRef as ReactComponent };